// src/api/dummyApi.js
// export const fetchClaimData = async (query) => {
//     return {
//       claim: query,
//       verdict: "Highly False",
//       records: [
//         { meeting: "Treasury Amendment", chamber: "House of Rep.", date: "13 Dec 2020", link: "###" },
//         { meeting: "Cost of Living", chamber: "House of Rep.", date: "14 Dec 2020", link: "###" },
//         { meeting: "Treasury Amendment", chamber: "House of Rep.", date: "07 Dec 2020", link: "###" },
//       ],
//       positiveSpeech: 0,
//       positiveVotes: 0,
//     };
//   };

// Example of Real API here. Swap after it's finalised
// export const fetchClaimData = async (query) => {
//   try {
//     const response = await fetch(
//       `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3/ai_claim_check_v3?claim=${encodeURIComponent(
//         query
//       )}`,
//       {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     if (!response.ok) {
//       throw new Error(`API error: ${response.status}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Error fetching data:", error);
//     return null;
//   }
// };


export const fetchClaimData = async (query) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3/ai_claim_check_v3?claim=${encodeURIComponent(
        query
      )}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      // For 400 errors, parse the response to get the error_reason
      if (response.status === 400) {
        const errorData = await response.json();
        throw new Error(JSON.stringify({
          type: "VALIDATION_ERROR",
          message: errorData.error || "Invalid input"
        }));
      }
      
      // For other errors
      throw new Error(`API_ERROR_${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    
    try {
      // Try to parse the error message if it's a JSON string
      const errorObj = JSON.parse(error.message);
      
      if (errorObj.type === "VALIDATION_ERROR") {
        return { 
          error: true, 
          type: "validation", 
          message: errorObj.message 
        };
      }
    } catch (parseError) {
      // Not a JSON error, continue with other error handling
    }
    
    // Handle other API errors
    if (error.message.startsWith("API_ERROR_")) {
      return { 
        error: true, 
        type: "api", 
        code: error.message.split("_")[2], 
        message: "API request failed" 
      };
    }
    
    // Network or other errors
    return { 
      error: true, 
      type: "network", 
      message: "Network or server error" 
    };
  }
};

// Function to fetch an existing claim by search ID
export const fetchClaimById = async (searchId) => {
  try {
    const response = await fetch(
      `https://lmkbvv7mzl.execute-api.ap-southeast-2.amazonaws.com/v3/ai_claim_check_v3?searchID=${searchId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};